<div class ="end">
<app-header></app-header>
<div class="bg1 d-flex flex-column justify-content-center">
	<div class="d-flex flex-column justify-content-center text-center my-3 m-end-success">
		<div class="mmb-1">
			<i class="img done-list"></i>
		</div>
		<h2 class="h2">{{'END.TITLE_1'|translate}}</h2>
		<div class="h3">{{'END.MSG_1'|translate}}</div>
		<div class="h3">{{'END.MSG_2'|translate}}</div>
		<div class="h5">{{'END.MSG_3'|translate}}</div>
	</div>

	<!-- <div class="text-center my-5 pb-5">
		<img class="w-100 mb-2" src="assets/images/end/apps-banner.png">
		<div>
			<h3 class="h2 m-5">{{'END.MSG_2'|translate}}</h3>
		</div>
		<div>
			<img class="w-75" src="assets/images/end/progress-banner.png">
		</div>
	</div>  -->
	<!-- <div class="m-end-progress text-center justify-content-center" style="background-color: #fff;">
		<h3 class="h3 mb-2">{{'END.MSG_2'|translate}}</h3>
	
		<img class="w-75" src="assets/images/end/progress-banner.png">
	</div> -->
	<!-- <div class="m-end-app text-center pb-5">
			<h2 class="h2 mt-3 mb-3">{{'END.APP_TITLE'|translate}}</h2>
			<h5>{{'END.APP_MSG_1'|translate}}</h5>
			<h5>{{'END.APP_MSG_2'|translate}}</h5>
			<div class="row no-gutters justify-content-center text-center mt-5">
				<div class="col-md-3 col-12 mb-2">
					<a href="https://play.google.com/store/apps/details?id=com.MizrahiTefahot.mash" >
						<img src="assets/images/end/goolePlay.png">
					</a>    
				</div>
				<div class="col-md-3 col-12 mb-2">
					<a href="https://itunes.apple.com/us/app/id1117765525">
						<img src="assets/images/end/appStore.png">
					</a>
				</div>
			</div>  
		</div> -->
	
	

	<!-- <div class="m-end-todo text-center container mx-auto mt-4 mb-0">
		<h3 class="h3">{{'END.TITLE_2'|translate}}</h3>
		<div class="row no-gutters d-flex m-2 m-md-4 mb-0">
			<div class="text-right col-lg col-12">
				<div>
					<h4><span class="rounded-circle">1</span>{{'END.TITLE_3'|translate}}</h4>
				</div>
				<div class="pr-5">
					{{'END.INFO_1'|translate}} <br>
					<div class="m-end-note mt-3">
						{{'END.INFO_1_NOTE_1'|translate}} <br/>
						{{'END.INFO_1_NOTE_2'|translate}}
					</div>				
				</div>
			</div>
			<div class="text-right col-lg col-12">
				<div>
					<h4><span class="rounded-circle">2</span>{{'END.TITLE_4'|translate}}</h4>
				</div>
				<div class="pr-5">
					{{'END.INFO_2'|translate}}
				</div>
			</div>
			<div class="text-right col-lg col-12">
				<div>
					<h4><span class="rounded-circle">3</span>{{'END.TITLE_5'|translate}}</h4>
				</div>
				<div class="pr-4">
					<ul>
						<li *ngFor="let doc of requiredDocs">{{doc}}</li>
					</ul>
				</div>
			</div>
		</div>
	</div> -->
	<!-- <hr/>  -->
</div>
<div class="bg2">
	<div class="text-center mx-auto container">
		<h2 class="h2 mb-3">{{'END.TITLE_6'|translate}}</h2>
		<div class="m-expert row no-gutters d-flex mx-auto text-center w-100 mb-4">
			<div class="col-md col-12 p-2">
				<img class="w-100" src="assets/images/end/computer.png">
				<h4 class="mt-4">{{'END.TITLE_7'|translate}}</h4>
				<div class="m-3">
					{{'END.INFO_4'|translate}}
				</div>
				<a target="_blank" class="m-more-data-link" href="https://www.mizrahi-tefahot.co.il/he/Bank/mortgage-category/pages/calculator.aspx">{{'END.MORE_DATA'|translate}}</a>
			</div>
			<div class="col-md col-12 p-2">
				<img class="w-100" src="assets/images/end/maakav.png">
				<h4 class="mt-4">{{'END.TITLE_8'|translate}}</h4>
				<div class="m-3">
						{{'END.INFO_5'|translate}}
				</div>
				<a target="_blank" class="m-more-data-link" href="https://www.mizrahi-tefahot.co.il/mortgages/ckeckmortgage/gps/">{{'END.MORE_DATA'|translate}}</a>
			</div>
			<div class="col-md col-12 p-2">
				<img class="w-100" src="assets/images/end/tmunat-mazav.png">
				<h4 class="mt-4">{{'END.TITLE_9'|translate}}</h4>
				<div class="m-3">
						{{'END.INFO_6'|translate}}
				</div>
				<a target="_blank" class="m-more-data-link" href="https://www.mizrahi-tefahot.co.il/he/Bank/mortgage-category/pages/where_to_buy.aspx">{{'END.MORE_DATA'|translate}}</a>
			</div>
		</div>
	</div>
</div>
</div>



// WEBPACK FOOTER //
// ./src/app/end-page/end-page.component.html